import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { videoApi } from "../../../../config/videoApi";
import {
  lectureCategories,
  lectureModels,
} from "../../../main/components/RecommendLeture";

const cardStyle: React.CSSProperties = {
  backgroundColor: "#243044",
  border: "1px solid rgba(255,255,255,0.12)",
  color: "#e2e8f0",
};

const cardBodyStyle: React.CSSProperties = {
  backgroundColor: "#243044",
  color: "#e2e8f0",
};

const LectureListSection = () => {
  const history = useHistory();
  const [lectures, setLectures] = useState<any>([]);
  const [activeCategory, setActiveCategory] = useState<string | null>(null);

  useEffect(() => {
    getCourse();
  }, []);

  const getCourse = async (filter?: string) => {
    try {
      const res = await videoApi.getCourseListAsync();
      res.data.courses.sort((a: any, b: any) =>
        a.order < b.order ? -1 : a.order > b.order ? 1 : 0
      );

      let searchModels = lectureModels;
      if (filter) {
        searchModels = lectureModels.filter(
          (lecture) => lecture.category === filter
        );
      }
      const orderedCourses = searchModels
        .map((lectureModel) =>
          res.data.courses.find((course: any) => course.id === lectureModel.id)
        )
        .filter(Boolean);
      setLectures(orderedCourses);
    } catch (e) {
      console.error("강의목록 로드 실패:", e);
    }
  };

  return (
    <section>
      <div className="container page">
        <div className="section-header text-white">강의목록</div>
        <div className="frame" style={{ overflow: "hidden" }}>
          <ul
            className="nav nav-tabs slidee white-ver"
            id="myTab"
            role="tablist"
          >
            <li className="nav-item" role="presentation" key="all">
              <button
                className={`nav-link${activeCategory === null ? " active" : ""}`}
                type="button"
                role="tab"
                aria-selected={activeCategory === null}
                onClick={() => {
                  setActiveCategory(null);
                  getCourse();
                }}
              >
                전체
              </button>
            </li>
            {lectureCategories.map((category) => (
              <li className="nav-item" role="presentation" key={category}>
                <button
                  className={`nav-link${activeCategory === category ? " active" : ""}`}
                  type="button"
                  role="tab"
                  aria-selected={activeCategory === category}
                  onClick={() => {
                    setActiveCategory(category);
                    getCourse(category);
                  }}
                  disabled={category.includes("준비")}
                >
                  {category}
                </button>
              </li>
            ))}
          </ul>
          <div className="tab-content mt-6" id="myTabContent">
            <div className="tab-pane fade show active" tabIndex={0}>
              <div
                className="card-wrap column3"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                {lectures.map((lecture: any) => {
                  const starCount = Math.floor(lecture.rating || 0);
                  const userCount = lectureModels.find(
                    (m) => m.id === lecture.id
                  )?.userCount;
                  return (
                    <div
                      className="card pointer"
                      key={lecture.id}
                      style={cardStyle}
                      onClick={() =>
                        history.push(`video/curriculum/${lecture.id}`)
                      }
                    >
                      <img
                        src={lecture.card_image}
                        className="card-img-top"
                        alt={lecture.title}
                        style={{ aspectRatio: "16/9", objectFit: "cover" }}
                      />
                      <div className="card-body" style={cardBodyStyle}>
                        <h5 className="card-title" style={{ color: "#fff" }}>
                          {lecture.title}
                        </h5>
                        <div className="body2 mb-2" style={{ color: "#94a3b8" }}>
                          {lecture.description}
                        </div>
                        <div className="card-text mb-2">
                          <div className="card-caption">
                            {lecture.rating != null && (
                              <div className="rating">
                                <span>{lecture.rating.toFixed(1)}</span>
                                <div className="star-wrap">
                                  {Array.from({ length: starCount }).map(
                                    (_, i) => (
                                      <span key={i}></span>
                                    )
                                  )}
                                </div>
                              </div>
                            )}
                            <div className="price" style={{ color: "#fff", fontWeight: 700 }}>
                              <span className="discount" style={{ color: "#8b9ab8" }}>
                                <span>
                                  {lecture.origin_amount.toLocaleString()}
                                </span>
                                원
                              </span>
                              <span>{lecture.amount.toLocaleString()}</span>원
                            </div>
                          </div>
                        </div>
                        <div className="badge-wrap">
                          {userCount != null && (
                            <span
                              className="badge rounded-pill"
                              style={{
                                backgroundColor: "rgba(99,102,241,0.15)",
                                color: "#a5b4fc",
                              }}
                            >
                              {userCount}명
                            </span>
                          )}
                          <span
                            className="badge rounded-pill"
                            style={{
                              backgroundColor: "rgba(99,102,241,0.25)",
                              color: "#c7d2fe",
                            }}
                          >
                            {lecture.service_product}
                          </span>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LectureListSection;
